import client from './client';

export const getBankChannels = async (includeInactive = false, module = 'retail') => {
  const response = await client.get(`/bank-channels?include_inactive=${includeInactive}&module=${module}`);
  return response.data;
};

export const createBankChannel = async (data, module = 'retail') => {
  const response = await client.post('/bank-channels', { ...data, module });
  return response.data;
};

export const updateBankChannel = async (id, data) => {
  const response = await client.put(`/bank-channels/${id}`, data);
  return response.data;
};

export const deleteBankChannel = async (id) => {
  const response = await client.delete(`/bank-channels/${id}`);
  return response.data;
};
